module.exports = __webpack_public_path__ + "assets-cabinet/img/cal-arrow-right.ab492f2f.svg";